import { useCallback, useMemo, useState } from "react";
import { ENodeTypes, TNode } from "../../types";
import * as Icons from 'react-icons/bs';
import { TreeLeaf } from "./TreeLeaf";
import { DottedPlaceholder, EDottedPlaceholder } from "./DottedPlaceholder";

export const TreeNode = (node: TNode & { fetcher?: (...props: any) => any }) => {

    const [collapsed, setCollapsed] = useState(true);
    const [children, setChildren] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleClick = useCallback(async () => {
        if (node.loadArgs) {
            setLoading(true);
            setCollapsed(prev => !prev)
            // console.log('fetching')
            const data = await node.fetcher?.(...node.loadArgs)
            setChildren(data || []);
            // console.log(data)
            setLoading(false);
        } else {
            setCollapsed(prev => !prev)
        }
    }, [node]);

    const nodeChildren = useMemo(() => node.children && node.children.length > 0 ? node.children : children, [children, node.children])

    return (
        <div className='lint-tree-node'>
            <div className='lint-tree-node-header' onClick={() => handleClick()}>
                <div className="lint-tree-icon small">
                    {
                        collapsed
                            ? <Icons.BsPlusSquare />
                            : <Icons.BsDashSquare />
                    }
                </div>
                <Icons.BsFolderFill className='collapsible-folder-icon align-self-center lint-tree-icon' />
                <div className='lint-tree-text text-ellipsis'>{node.title}</div>
            </div>
            {
                !collapsed
                    ? <div className='lint-tree-node-body'>
                        <DottedPlaceholder type={EDottedPlaceholder.VERTICAL} />
                        {
                            !loading
                                ? <div className='lint-tree-node-children'>
                                    {
                                        nodeChildren.map((n, idx) => n.type === ENodeTypes.NODE
                                            ? <TreeNode key={`${idx}-${n.title}-${n.depth}`} {...n} fetcher={node.fetcher} />
                                            : <TreeLeaf key={`${idx}-${n.data.title}-f`} {...n} fetcher={node.fetcher} last={idx === nodeChildren.length - 1 ? true : false} />
                                        )
                                    }
                                </div>
                                : <i className="fa fa-spinner fa-spin" />
                        }
                    </div>
                    : null
            }

        </div>
    )
}

// export const VintageDocNode = props => {
//     const {
//         _id, title, type, nr, issue_year, onDocOpen
//     } = props
//     const text = `${nr}/${issue_year} ${title}`
//     return (
//         <div className="d-flex flex-column doc position-relative">
//             <a href={`/view/${_id}`} className="vintage doclink" target="_self" rel="noreferrer" onClick={onDocOpen} title={text}>
//                 <Icons.BsFileEarmarkTextFill className='collapsible-file-icon align-self-center mr-1' />
//                 {text}
//             </a>
//         </div>
//     )
// }
